import React from "react";
import { Helmet } from "react-helmet";
import { Location } from "@reach/router";

const PageHelmet = ({ title,children }:any) => {
  return (
    <>
      <Location>
        {({ location }) => {
          return (
            <Helmet>
              {title && <title>{title}</title>}

              {children && children}
            </Helmet>
          );
        }}
      </Location>
    </>
  );
};

export default PageHelmet;
